import React from 'react';
import PropTypes from 'prop-types';

import {
  Button,
  ContainerButton,
  ContainerTitle,
  Modal,
} from './styles';

const ModalWithoutClips = (props) => {
  const {
    id,
    type,
    onEdit,
    onClose,
  } = props;
  const handleEditClip = () => {
    onClose();
    onEdit(id);
  };

  return (
    <Modal
      size="mini"
      closeOnEscape={onClose}
      closeOnDimmerClick={onClose}
      open
      onClose={onClose}
    >
      <ContainerTitle>
        {`You haven’t added any clips to your highlight reel so there’s nothing to ${type}.`}
      </ContainerTitle>
      <ContainerButton>
        <Button onClick={handleEditClip}>
          Edit your highlight reel
        </Button>
      </ContainerButton>
    </Modal>
  );
};

ModalWithoutClips.propTypes = {
  id: PropTypes.string.isRequired,
  type: PropTypes.string.isRequired,
  onEdit: PropTypes.func.isRequired,
  onClose: PropTypes.func.isRequired,
};

export default ModalWithoutClips;
